<template>
  <div class="menu">
    <!-- <img src="../../common/images/menuname.png" alt="" class="mname" @click="systemChange" /> -->
    <div class="mname" @click="systemChange"></div>
    <div class="menulist">
      <ul class="menutab">
        <li v-for="(item, i) in menuList" :key="i" :class="activelen == i ? 'active' : ''" @click="tab(item, i)">{{
      item.name }}
        </li>
      </ul>
    </div>
    <div class="headtime">
      <div class="time">
        <div class="timeh">
          <h6>{{ Hours }}</h6>
          <h6 class="m">:</h6>
          <h6>{{ Minutes }}</h6>
          <h6 class="m">:</h6>
          <h6>{{ Seconds }}</h6>
        </div>
        <div class="week">
          <p>{{ dataofweek }}</p>
          <p class="weektext">{{ week }}</p>
        </div>
      </div>
      <div class="right-operation">
        <div class="user" @click="signout">
          <p>退出</p>
          <span class="iconfont icon-tuichu"></span>
        </div>
        <div class="user">
          <p>{{ username }}</p>
          <span class="iconfont icon-subscriber-fill"></span>
        </div>
        <el-popover placement="bottom" width="320" trigger="click" v-model="visible">
          <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="70px">
            <el-form-item label="原密码" prop="origpass">
              <el-input type="password" v-model="ruleForm.origpass" autocomplete="off" show-password></el-input>
            </el-form-item>
            <el-form-item label="新密码" prop="pass">
              <el-input type="password" v-model="ruleForm.pass" autocomplete="off" show-password></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="checkPass">
              <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off" show-password></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
              <el-button @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
          </el-form>
          <div class="password" slot="reference">
            <p>修改密码</p>
            <span class="el-icon-edit-outline"></span>
          </div>
        </el-popover>
      </div>
    </div>

    <resetPassword v-if="passShow" @getcancel="Getcancel"></resetPassword>
  </div>
</template>

<script>
import {
  ydbtree,
  logouts,
  menulist,
  password,
  originPassword
} from '@/api/api.js'
import resetPassword from '@/components/mangement/resetPassword.vue'
export default {
  data() {
    var origindatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入原密码'));
      } else {
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else if (value.length < 8) {
        callback(new Error('密码不能少于8个字符'));
      } else {
        //判断密码是否符合
        // let numArr = value.match(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}$/);
        let numArr = value.match(/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[\W_]).{8,}$/);
        if (numArr == null) {
          callback('密码须包括大写字母，小写字母，数字和特殊字符四种类型');
        } else {
          if (this.ruleForm.checkPass !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      username: this.$store.state.name,
      Hours: null,
      Minutes: null,
      Seconds: null,
      dataofweek: null,
      week: null,
      menuList: [],
      activelen: 0,
      urlList: [],

      visible: false,
      ruleForm: {
        origpass: '',
        pass: '',
        checkPass: ''
      },
      rules: {
        origpass: [{
          validator: origindatePass,
          trigger: 'blur'
        }],
        pass: [{
          validator: validatePass,
          trigger: 'blur'
        }],
        checkPass: [{
          validator: validatePass2,
          trigger: 'blur'
        }]
      },

      passShow: false,
    };
  },
  components: {
    resetPassword
  },
  mounted() {
    console.log(this.$store.state.type)
    console.log(this.$store.state.name)
    this.list();
    this.SetDate();
    //判断密码是否修改，强制修改
    originPassword({}).then((res) => {
      if (res.data == true) {
        this.passShow = true;
      } else {
        this.passShow = false;
      }
    })
  },
  watch: {
    $route(to, from) {
      if (this.urlList.length != 0) {
        // console.log(this.urlList)
        if (this.urlList.indexOf(to.path.slice(1)) == -1) {
          this.$router.replace(from.path)
        }
      }
    },
  },
  methods: {
    //从驾驶舱直接切换到业务系统
    systemChange() {
      this.$router.replace("indexpage");
      // this.$router.replace("floodcontrolmanagement");
    },

    list() {
      let params = {
        userId: this.$store.state.userid
      };
      menulist(params).then((res) => {
        console.log("3.21下午111", res.data)
        res.data.sort((a, b) => a.orderNum - b.orderNum);
        res.data.forEach(menu => {
          if (menu.children && menu.children.length > 0) {
            menu.children.sort((a, b) => a.orderNum - b.orderNum);
          }
        });
        //res.data.children.sort((a, b) => a.orderNum - b.orderNum);
        this.menuList = res.data;
        // this.menuList[0].children.push({
        //   "id": 39,
        //   "createDate": "2022-05-25 11:25:36",
        //   "updateDate": null,
        //   "userId": 16,
        //   "deptId": 1,
        //   "remark": null,
        //   "delFlag": 0,
        //   "orderNum": 8,
        //   "parentId": 8,
        //   "parentName": null,
        //   "name": "淤积调查",
        //   "url": "yjdc",
        //   "perms": "1",
        //   "type": 1,
        //   "icon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAASCAYAAAC9+TVUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHpJREFUeNqkkUEOhCAMRYs3GM8lbucWutMLeC40mRupG1dY9C+MwFjwJy+xfP22lGy6RoaukM3TGAshAd9QUGoIhTpSx9enFMlkb/WU04k3Wk4nXleF8GXNGGYB7rnCj5VknOHPqgfJdip4G9MwJWhw5qSfQgy8NuD18MxTyAyvRP0DhDOnucjYiPLqF+N00nH07WI/IHqxISWvOBbiqDHaCgy6PPxdgAEAESwSHdycr90AAAAASUVORK5CYII=",
        //   "open": null,
        //   "list": null,
        //   "children": [],
        //   "activeicon": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAASCAYAAAC9+TVUAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAHpJREFUeNpi/PskgoEI8B+LGCOMwcRABcCCwxasNkLZ/9FdSDWXYLORJEB1l6DHAuOAuoSR2t4h2lBSvfOfZt5hwmITOgaB6WjqppPjnVwg3gdlg+g8fIYwYsEg8BeIg4B4BxAHA/EffGGCD3wEYk9CAft/QPMOQIABADcNF4Lj5GDAAAAAAElFTkSuQmCC"
        // });
        // for (let i = 0; i < this.menulist.length; i++) {
        //   for (let j = 0; j < this.menulist[i].children.length; j++) {
        //     if(orderNum[i] > orderNum[i+1]) {
        //       [orderNum[i], orderNum[i+1]] = [orderNum[i+1], orderNum[i]];
        //     }
        //   }
        // }

        this.$store.commit('towmenulist', this.menuList[0].children); //token
        this.$router.replace(this.menuList[0].children[0].url);

        for (let i = 0; i < this.menuList.length; i++) {
          let children = this.menuList[i].children;
          for (let j = 0; j < children.length; j++) {
            this.urlList.push(children[j].url);
          }
        }
      })
    },

    signout() {
      //this.$router.replace('siginin')
      this.$confirm("确定退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((action) => {

        if (action === "confirm") {
          let params = {};
          this.$router.replace("siginIn");
          logouts(params).then((res) => {
            console.log(res)
            if (res.code == 200) {
              window.localStorage.clear();
              this.$store.commit("toKen", null);
              this.$store.commit("userId", null);
              this.$store.commit("naMe", null);
              this.$store.commit("unIt", null);
              this.$store.commit("Tel", null);
              this.$router.replace("siginIn");

            }
          });
        }
      })
        .catch(() => {
          /* this.$message({
                  type: 'info',
                  message: '已取消退出'
                }); */
        });

    },
    tab(item, i) {
      this.activelen = i;
      this.$store.commit('towmenulist', item.children); //token
      //this.$router.replace(item.child[0].href)

    },
    SetDate() {
      let tmpArr = new Array(
        '星期日',
        '星期一',
        '星期二',
        '星期三',
        '星期四',
        '星期五',
        '星期六'
      )
      let myDate = new Date()
      let _this = this
      this.Hours = this.timenum(myDate.getHours())
      this.Minutes = this.timenum(myDate.getMinutes())
      this.Seconds = this.timenum(myDate.getSeconds())

      // this.Time =  + ":"+this.timenum(myDate.getMinutes()) + ":"+this.timenum(myDate.getSeconds());
      this.dataofweek = myDate.getFullYear() + '.' + (myDate.getMonth() + 1) + '.' + myDate.getDate();

      this.week = tmpArr[myDate.getDay()]
      window.setTimeout(_this.SetDate, 1000)
    },
    timenum(num) {
      if (num < 10) {
        return '0' + num
      } else {
        return num
      }
    },

    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // console.log(this.ruleForm)
          let params = {
            password: this.ruleForm.origpass,
            newPassword: this.ruleForm.pass
          };
          password(params).then((res) => {
            console.log(res.message)
            if (res.code == 500) {
              this.$message.error(res.message);
            } else {
              this.$message({
                message: '修改成功',
                type: 'success'
              });
              this.ruleForm.origpass = '';
              this.ruleForm.pass = '';
              this.ruleForm.checkPass = '';
              this.visible = false;

              //自动登出
              let params1 = {};
              this.$router.replace("siginIn");
              logouts(params1).then((res) => {
                if (res.code == 200) {
                  window.localStorage.clear();
                  this.$store.commit("toKen", null);
                  this.$store.commit("userId", null);
                  this.$store.commit("naMe", null);
                  this.$store.commit("unIt", null);
                  this.$store.commit("Tel", null);
                  this.$router.replace("siginIn");
                }
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    Getcancel(data) {
      this.dialogVisible = data.dialogVisible;
    },
  }

}
</script>

<style scoped>
.menu {
  width: 100%;
  height: 60px;
  background: url(../../common/images/menu.jpg)no-repeat center;
  background-size: 100% 100%;
}

.mname {
  width: 390px;
  height: 60px;
  display: block;
  float: left;
  cursor: pointer;
}

.menulist {
  width: calc(100% - 760px);
  width: -webkit-calc(100% - 760px);
  width: -moz-calc(100% - 760px);
  height: 100%;
  float: left;
}

.headtime {
  float: right;
  width: 370px;
  height: 60px;
  background: url(../../common/images/headtime.png)no-repeat center;
  background-size: 100% 100%;
}

.time {
  width: 156px;
  height: 60px;
  float: right;
}

.time p {
  text-align: center;
  line-height: 14px;
  font-size: 12px;
  color: #fff;
}

.time p:nth-child(1) {
  margin-top: 17px;
}

.timeh {
  width: 90px;
  height: 60px;
  float: left;
}

.timeh h6 {
  font-size: 20px;
  color: #fff;
  line-height: 60px;
  float: left;
  text-align: center;
}

.m {}

.week {
  width: 60px;
  height: 60px;
  float: left;
}

.weektext {
  letter-spacing: 8px;
}

.right-operation {
  width: 170px;
  float: right;
}

.user {
  float: right;
  height: 64px;
}

.user:nth-child(1) {
  width: 60px;
  margin-right: 6px;
  height: 50%;
}

.user:nth-child(2) {
  width: 78px;
  margin-right: 2px;
  height: 50%;
}

.user span {
  float: right;
  font-size: 14px;
  color: #fff;
  margin-top: 10px;
}

.user:nth-child(2) p {
  width: 37px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: right;
  border-right: 1px solid #4b77ba;
}

.user p {
  font-size: 12px;
  color: #fff;
  float: right;
  margin-top: 10px;
  margin-left: 6px;
  cursor: pointer;
  /* border-right: 1px solid #4b77ba; */
  padding-right: 8px;
}

.password {
  width: 100%;
  float: right;
  height: 30px;
  color: #fff;
}

.password p {
  float: right;
  margin-right: 35px;
  height: 25px;
  line-height: 25px;
  cursor: pointer;
}

.password span {
  float: right;
  height: 25px;
  line-height: 25px;
  margin-right: 5px;
}

.menutab {
  width: 100%;
  height: 50px;
  padding-top: 10px;
}

.menutab li {
  float: left;
  height: 40px;
  width: 130px;
  text-align: center;
  line-height: 40px;
  color: #fff;
  background: url(../../common/images/tabbg.png)no-repeat center;
  background-size: 100% 100%;
  margin: 0 6px;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 1px;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
  cursor: pointer;
}

.menutab li:hover {
  transform: scale(1.02);
  -ms-transform: scale(1.02);
  -moz-transform: scale(1.02);
  -webkit-transform: scale(1.02);
  -o-transform: scale(1.02);
  color: #fde458 !important;
}

.active {
  background: url(../../common/images/active.png)no-repeat center !important;
  background-size: 100% 100% !important;
  color: #fde458 !important;
}

>>>.el-input__inner {
  height: 30px;
  line-height: 30px;
}

>>> .el-form-item__error {
  padding-top: 0;
  left: -68px;
}

>>>.el-form-item__content {
  text-align: center;
}

>>>.el-popover {
  padding-bottom: 0;
}
</style>
